import React from 'react';
import { MsalProvider } from '@azure/msal-react';
import RouteComponent from './routes/routeComponent';
import { msalInstance } from './shared/config/msalConfig';

function App() {
  return (
    <MsalProvider instance={msalInstance}>
      <div>
        <RouteComponent />
      </div>
    </MsalProvider>
  );
}

export default App;
